module.exports = __webpack_public_path__ + "static/fx_15.50bd8b08.jpg";